import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { supportQueries } from '@/entities/support'
import { UserType } from '@/entities/user'

type Props = {
  userType: UserType
  page: number
}

export const useNotices = ({ userType, page }: Props) => {
  const { data } = useQuery({
    ...supportQueries.notices(userType, { page }),
    placeholderData: keepPreviousData,
    meta: {
      useCustomHandling: true,
    },
  })

  const notices = data?.content ?? []
  const lastPage = data?.lastPage || 1

  return {
    notices,
    lastPage,
  }
}
